<div class="filter-actions__start">
  <button type="button" class="button-search" mat-raised-button color="warn" (click)="resetFilters.emit()">
    {{ 'common.filters.warehouseMovements.resetFilters' | translate }}
  </button>
  <ng-content></ng-content>
</div>
<button type="button" class="searchFocus button-search" mat-raised-button color="primary"
  [disabled]="searchDisabled" (click)="searchFilters.emit($event)">
  {{ 'common.filters.warehouseMovements.buttonSearch' | translate }}
  <mat-icon class="iconSearch">search</mat-icon>
</button>
